// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export const DEFAULT_RETRY_ATTEMPTS = 3;
export const AMZ_SDK_INVOCATION_ID_HEADER = 'amz-sdk-invocation-id';
export const AMZ_SDK_REQUEST_HEADER = 'amz-sdk-request';
export const DEFAULT_MAX_DELAY_MS = 5 * 60 * 1000;
